import { IMarketoField } from './marketo/@types/fields'

/**
 * These forms are loaded into EVERY page.
 * Before adding more hardcoded forms here please note this will impact the site performance.
 *
 * If you add a form here, you'll need to add the form ID to EMS before:
 * https://github.com/intercom/github-management-service/blob/f8bdb2b7a0991c2c0d1369a736839badce8941d5/app/lib/event_management_system/action_processors/marketing_site/importers/marketo_forms.rb#L9
 */
export const marketoFormIds = {
  books: 1021,
  webinar: 1022,
  exitIntentPopup: 1533,
  finDemo: 2157,
}

const marketoAccountId = '258-CLW-344'

export const marketoTrackingCookieName = '_mkto_trk'

export const getMarketoCookieRegex = (hostname?: string): string =>
  `^id:${marketoAccountId}&token:_mch-${hostname || '(\\w+\\.)+\\w+'}-\\d+-\\d{5}$`

// TODO: verify value matches type and length requirements
export const verifyFormStructure = (
  formFields: Record<string, any>,
  fieldsDef: IMarketoField[],
): boolean => {
  let isInputValid = true
  for (let i = 0; i < fieldsDef.length; i++) {
    const field = fieldsDef[i]
    if (field.required && !(field.id in formFields)) {
      isInputValid = false
      break
    }
  }
  return isInputValid
}
